import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import 'react-widgets/dist/css/react-widgets.css';
import {Modal,Button} from 'react-bootstrap'
import {ButtonToolbar,Dropdown,SplitButton,ReactBootstrapStyle,DropdownButton} from 'react-bootstrap';
import ProteccionIcon from '@material-ui/icons/AccessibilityNewRounded';
import DgdueIcon from '@material-ui/icons/Panorama';
import Grid from '@material-ui/core/Grid';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import { GetDocumentosID, GetRequisitos, imprimir,PostInspeccion,PostInspeccionPC,PostRegulacion,UPDACR,UPDCR,UPDCT,UPDCTCM,UPDCTE,UPDNoregistro,UPDOCR,UPDOVR} from '../../services/SecurityService';

import DatosOficio from './DatosOficio';

import backgroundFPC from "./formatoPC.jpg";
import { Document, Page, Text, View, StyleSheet,Font , PDFViewer, PDFDownloadLink,Image} from "@react-pdf/renderer";


import RegistroOficio2 from './RegistroOficio2';
import RegistroOficio3 from './RegistroOficio3';
import RegistroOficio4 from './RegistroOficio4';
import RegistroOficio2U from './RegistroOficio2U';
import background from "./sm.jpg";
import background2 from "./snr.jpg";
import background3 from "./cs.jpg";
import background4 from "./cnrs.jpg";
import formato1 from "./formato1.jpg";
import formato2 from "./formato2 - copia.jpg";
import l1 from "./5629-font.ttf";
import l2 from "./5631-font.ttf";
import l3 from "./5630-font.ttf";
import l4 from "./5632-font.ttf";

class TableRow extends Component {

  constructor(props, context) {
    super(props, context);
  
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleShowCN = this.handleShowCN.bind(this);
    this.handleCloseCN = this.handleCloseCN.bind(this);
    this.handleShowCNa = this.handleShowCNa.bind(this);
    this.handleCloseCNa = this.handleCloseCNa.bind(this);
    this.handleShowCN2 = this.handleShowCN2.bind(this);
    this.handleCloseCN2 = this.handleCloseCN2.bind(this);
    this.handleShow2 = this.handleShow2.bind(this);
    this.handleClose2 = this.handleClose2.bind(this);
    this.handleShow2_1 = this.handleShow2_1.bind(this);
    this.handleClose2_1 = this.handleClose2_1.bind(this);
    this.handleShow2_2 = this.handleShow2_2.bind(this);
    this.handleClose2_2 = this.handleClose2_2.bind(this);
    this.handleShow3 = this.handleShow3.bind(this);
    this.handleClose3 = this.handleClose3.bind(this);

    this.handleShow4 = this.handleShow4.bind(this);
    this.handleClose4 = this.handleClose4.bind(this);
    this.handleShow5 = this.handleShow5.bind(this);
    this.handleShowCancelado = this.handleShowCancelado.bind(this);
    this.handleShowDesCancelado = this.handleShowDesCancelado.bind(this);
    this.handleClose5 = this.handleClose5.bind(this);
    this.handleCloseCancelado = this.handleCloseCancelado.bind(this);
    this.handleCloseDesCancelado = this.handleCloseDesCancelado.bind(this);
    this.handleShow6 = this.handleShow6.bind(this);
    this.handleClose6 = this.handleClose6.bind(this);

    this.handleShow7 = this.handleShow7.bind(this);
    this.handleClose7 = this.handleClose7.bind(this);

    this.handleShow8 = this.handleShow8.bind(this);
    this.handleClose8 = this.handleClose8.bind(this);

    this.handleShow82 = this.handleShow82.bind(this);
    this.handleClose82 = this.handleClose82.bind(this);

    this.handleShowFPC = this.handleShowFPC.bind(this);
    this.handleCloseFPC = this.handleCloseFPC.bind(this);

    this.handleShowFCU = this.handleShowFCU.bind(this);
    this.handleCloseFCU = this.handleCloseFCU.bind(this);

    /*
    this.handleShowFSA = this.handleShowFSA.bind(this);
    this.handleCloseFSA = this.handleCloseFSA.bind(this);

    this.handleShowFEC = this.handleShowFEC.bind(this);
    this.handleCloseFEC = this.handleCloseFEC.bind(this);
*/
    //this.onSubmit = this.onSubmit.bind(this);
    this.onChangehorario = this.onChangehorario.bind(this);
    this.onChangeclave = this.onChangeclave.bind(this);
    this.onChangejd = this.onChangejd.bind(this);
    this.handlebtnOn = this.handlebtnOn.bind(this);
  //  this.pdf = this.pdf.bind(this);
    this.pdfsm = this.pdfsm.bind(this);
    this.pdfsnr = this.pdfsnr.bind(this);
    this.pdfcs = this.pdfcs.bind(this);
    this.pdfcsnr = this.pdfcsnr.bind(this);
    this.imp= this.imp.bind(this);

    this.onChangenombre = this.onChangenombre.bind(this);
      this.onChangeapellidopaterno = this.onChangeapellidopaterno.bind(this);
      this.onChangeapellidomaterno = this.onChangeapellidomaterno.bind(this);
      this.onChangecurp = this.onChangecurp.bind(this);
      this.onChangeclase = this.onChangeclase.bind(this);
      this.onChangetelefono = this.onChangetelefono.bind(this);
      this.onChangedomicilio = this.onChangedomicilio.bind(this);
      this.onChangefechareg = this.onChangefechareg.bind(this);

    this.pdfFormatoPC = this.pdfFormatoPC.bind(this);
    //this.pdfFormatoCU = this.pdfFormatoCU.bind(this);

    this.state = {
      btnOn: false,
      show: false,
      showCN: false,
      showCNa: false,
      showCN2: false,
      show2: false,
      show2_1: false,
      show2_2: false,
      show3: false,
      show4: false,
      show5:false,
      showCancelado:false,
      showDescancelado:false,
      show6:false,
      show7:false,
      show8:false,
      show82:false,
      showFPC:false,
      showFCU:false,
      showFSA:false,
      showFEC:false,
      horario:'',
      clave:'',
      Margen:0,
      MargenH:0,
      MargenT:0,
      jd:'C. SAID SINOHE GONZALEZ VAZQUEZ',
      requisitosF :[1,2,3,4,5,6,7,8,9,21,22,24,25,26,27,28],
      requisitosM :[1,2,3,4,20,6,7,8,9,10,21,22,24,25,26,27,28],
      Requisitos : [],
      documentosR:[],
      calle:'',
      colonia:'',
      numero:'',

      sm1:false,
      sm2:false,
      sm3:false,
      sm4:false,



      ap_paterno:'',
      ap_materno:'',
      nombre:'',
      CURP:'',
      clase:'',
      domicilio:'',
      telefono:'',

    };
  }

  componentDidMount(){


if(this.props.index==0){
    let a={ id_oficio : Number(this.props.obj.id_oficio)}
    /*
    GetDocumentosID(a).then(response => {
      this.setState({
      
        documentosR: response.map(d => d.id_documentos)
      });
   //     console.log("Esta madre no se q sea xD")
     //   console.log(response)
      }).catch(err => console.log(err)); 

    GetRequisitos().then(response => {
      //if(response=="")
   //   console.log("Requisitos VP")
 // console.log(response)
  this.setState({
    Requisitos : response
  });
    
  }).catch(err => console.log(err)); 

  */
}

  this.setState({
    horario:this.props.obj.horario,
    clave :this.props.obj.clave,
  //  jd:this.props.obj.jd
  })

  if(this.props.obj.jd=="" || this.props.obj.jd==null || this.props.obj.jd==undefined){
  
}else{
  this.setState({
   
    jd:this.props.obj.jd
  })
}


    }
  

  handleClose() {
    this.setState({ show: false });
  }
  
  handleShow() {
    this.setState({ show: true });
  }

  handleCloseCN() {
    this.setState({ showCN: false });
  }
  
  handleShowCN() {
    this.setState({ showCN: true });
  }
  handleCloseCNa() {
    this.setState({ showCNa: false });
  }
  
  handleShowCNa() {
    this.setState({ showCNa: true });
  }

  handleCloseCN2() {
    this.setState({ showCN2: false });
  }
  
  handleShowCN2() {
    this.setState({ showCN2: true });
  }

  handleClose2() {
    this.setState({ show2: false });
  }
  
  handleShow2() {
    this.setState({ show2: true });
  }

  handleClose2_1() {
    this.setState({ show2_1: false });
  }
  
  handleShow2_1() {
    this.setState({ show2_1: true });
  }

  handleClose2_2() {
    this.setState({ show2_2: false });
  }
  
  handleShow2_2() {
    this.setState({ show2_2: true });
  }

  handleClose3() {
    this.setState({ show3: false });
  }
  
  handleShow3() {
    this.setState({ show3: true });
  }

  handleShow4() {
    this.setState({ show4: true });
  }

  handleClose4() {
    this.setState({ show4: false });
  }

  handleShow5() {
    this.setState({ show5: true });
  }

  handleShowCancelado() {
    this.setState({ showCancelado: true });
  }

  handleShowDesCancelado() {
    this.setState({ showDescancelado: true });
  }

  handleClose5() {
    this.setState({ show5: false });
  }
  handleCloseCancelado() {
    this.setState({ showCancelado: false ,sm1:false,
      sm2:false,
      sm3:false,
      sm4:false,});
  }
  handleCloseDesCancelado() {
    this.setState({ showDescancelado: false });
  }

  handleShow6() {
    this.setState({ show6: true });
  }

  handleClose6() {
    this.setState({ show6: false });
  }

  handleShow7() {
    this.setState({ show7: true });
  }

  handleClose7() {
    this.setState({ show7: false });
  }

  handleShow8() {
    this.setState({ show8: true });
  }

  handleClose8() {
    this.setState({ show8: false });
  }

  handleShow82() {
    this.setState({ show82: true });
  }

  handleClose82() {
    this.setState({ show82: false });
  }

  handleShowFPC() {
    this.setState({ showFPC: true });
  }

  handleCloseFPC() {
    this.setState({ showFPC: false });
  }

  handleShowFCU() {
    this.setState({ showFCU: true });
  }

  handleCloseFCU() {
    this.setState({ showFCU: false });
  }
/*
  handleShowFSA() {
    this.setState({ showFSA: true });
  }

  handleCloseFSA() {
    this.setState({ showFSA: false });
  }


  handleShowFEC() {
    this.setState({ showFEC: true });
  }

  handleCloseFCU() {
    this.setState({ showFEC: false });
  }
*/

onChangenombre(e) {
  this.setState({
  nombre : e.target.value
  });
  }
  
  onChangeapellidopaterno(e) {
    this.setState({
    ap_paterno : e.target.value
    });
    }

    onChangeapellidomaterno(e) {
      this.setState({
      ap_materno : e.target.value
      });
      }

      onChangecurp(e) {
        this.setState({
        CURP : e.target.value
        });
        }

          onChangeclase(e) {
            const value = e.target.value.toUpperCase();
          
            // Limitar a 4 caracteres
            if (value.length <= 4) {
              this.setState({
                clase: value,
              });
            }
          }


          onChangedomicilio(e) {
            this.setState({
            domicilio : e.target.value
            });
            }

            onChangetelefono(e) {
              this.setState({
              telefono : e.target.value
              });
              }

              onChangefechareg(e) {
                this.setState({
                 fecha_reg : e.target.value
                });
                }

  onChangehorario(e) {
    this.setState({
    horario: e.target.value
    });
    }

    onChangeclave(e) {
      this.setState({
      clave: e.target.value
      });
      }
      onChangejd(e) {
        this.setState({
        jd: e.target.value
        });
        }

  handlebtnOn(boton) {
    let btn = !boton;
    this.setState({ btnOn: btn });
  }

  faltantes(){
    if(this.props.obj.persona_fm=="F"){
      console.log("Aqui estan los archivos faltantes")
      console.log(this.state.documentosR);
let a = this.state.requisitosF.filter(val => !this.state.documentosR.includes(val))
      console.log(this.state.requisitosF.filter(val => !this.state.documentosR.includes(val)));
let R = this.state.Requisitos

let aqui=[];
for(let i=0;i<a.length;i++){
console.log(a[i]);
for (let h=0;h<R.length;h++){
  if(a[i]==R[h].id_requisito){
  console.log(R[h].nombre);
aqui.push(R[h].nombre);
 // return <li>{R[h].nombre}</li>
  }
}
}




return aqui;


    }

    else if(this.props.obj.persona_fm=="M"){
   //   console.log("Aqui estan los archivos faltantes")
    //  console.log(this.state.documentosR);
let a = this.state.requisitosM.filter(val => !this.state.documentosR.includes(val))
   //   console.log(this.state.requisitosM.filter(val => !this.state.documentosR.includes(val)));
let R = this.state.Requisitos

let aqui=[];
for(let i=0;i<a.length;i++){
//console.log(a[i]);
for (let h=0;h<R.length;h++){
  if(a[i]==R[h].id_requisito){
//  console.log(R[h].nombre);
aqui.push(R[h].nombre);
 // return <li>{R[h].nombre}</li>
  }
}
}





return aqui;


    }

    
}

imp(){
 let a={horario:this.state.horario, clave:this.state.clave, jd:this.state.jd, id_oficio:this.props.obj.id_oficio}

  imprimir(a).then(response => {
   
     console.log(response)
    }).catch(err => console.log(err)); 
}





 //----------AQUI FORMATO PC
 pdfFormatoPC(obj){



  var hoy = new Date();

 


  return  (
<Document >
 <Page size={{width:612,height:792}} style={{ backgroundImage: `url(${backgroundFPC})` }}>
<View >
<Image
      src={backgroundFPC}
    />
</View>

<View style={{marginLeft:498,marginTop:123,alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text style={{ fontSize:11,textAlign:'center',color:'red'}}>{obj.nombre}</Text>
 </View>

 <View style={{marginLeft:448,marginTop:135,alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text style={{ fontSize:10,textAlign:'center'}}>{obj.nombre}</Text>
 </View>


 

{/* 
 <View style={{marginLeft:250,marginTop:643,alignItems:'center',position:'absolute',flexDirection:'row',spacing:120}}>
 <Image
      src={'https://tepic.gob.mx/1.png'}
      style={{height:'70',resizeMode:'cover'}}
    />
 </View>
*/}
 
</Page>
</Document>



);


 }


 

 
 pdfsm(obj){

let nnombre=this.props.obj.nombre+" "+this.props.obj.ap_paterno+" "+this.props.obj.ap_materno;
  var hoy = new Date();
  var hoy1 = new Date(this.props.obj.fecha_nac);

  var dd;
  
  if(hoy.getDate()<10){
    dd="0"+hoy.getDate();
  }else{
    dd= hoy.getDate();
  }
  
  var ms;
  
  if((hoy.getMonth()+1)<10){
    ms="0"+(hoy.getMonth()+1);
  }else{
    ms= (hoy.getMonth()+1);
  }
  
  var mm;
  if((hoy.getMonth()+1)==1){
  mm="Enero";
  }else if((hoy.getMonth()+1)==2){
    mm="Febrero";
  }else if((hoy.getMonth()+1)==3){
    mm="Marzo";
  }else if((hoy.getMonth()+1)==4){
    mm="Abril";
  }else if((hoy.getMonth()+1)==5){
    mm="Mayo";
  }else if((hoy.getMonth()+1)==6){
    mm="Junio";
  }else if((hoy.getMonth()+1)==7){
    mm="Julio";
  }else if((hoy.getMonth()+1)==8){
    mm="Agosto";
  }else if((hoy.getMonth()+1)==9){
    mm="Septiembre";
  }else if((hoy.getMonth()+1)==10){
    mm="Octubre";
  }else if((hoy.getMonth()+1)==11){
    mm="Noviembre";
  }else if((hoy.getMonth()+1)==12){
    mm="Diciembre";
  }

  var yyyy = hoy.getFullYear().toString()
  var yyyy2 = hoy1.getFullYear().toString()

  return  (
<Document >
<Page size={'LETTER'} style={{ backgroundImage:`url(${background})`}}>
<View >
<Image
style={{
  position: 'absolute',
  height: '100vh',
  width: '100vw',
}}
      src={background}
    />
</View>
<View style={{marginLeft:377,marginTop:175, flexDirection: 'row'}}>
 <Text style={{ fontSize:12}}>{dd}</Text>
 <Text style={{ fontSize:12,marginLeft:47}}>{mm}</Text>
   </View>



   <View style={{marginLeft:194,marginTop:316,alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text  fixed style={{ fontSize: nnombre.length >28 ? 10 : 12}}>{nnombre}</Text>
  </View> 

  <View style={{marginLeft:107,marginTop:336, flexDirection: 'row',alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text style={{ fontSize:this.state.calle.length > 19 ?10 : 12}}>{this.state.calle}</Text>
   </View>

   <View style={{marginLeft:300,marginTop:336, flexDirection: 'row',alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text style={{ fontSize:12}}>{this.state.numero}</Text>
   </View>

   <View style={{marginLeft:395,marginTop:336, flexDirection: 'row',alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text style={{ fontSize:this.state.colonia.length > 20 ? 10 : 12}}>{this.state.colonia}</Text>
   </View>

   <View style={{marginLeft:355,marginTop:358,alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text  fixed style={{ fontSize: 12}}>{this.props.obj.CURP}</Text>
  </View> 

  <View style={{marginLeft:160,marginTop:378,alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text  fixed style={{ fontSize: 12}}>{yyyy2}</Text>
  </View> 


  <View style={{marginLeft:430,marginTop:398,alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text  fixed style={{ fontSize: 12}}>{yyyy}</Text>
  </View> 

  <View style={{marginLeft:205,marginTop:508,alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text  fixed style={{ fontSize: nnombre.length >28 ? 10 : 12}}>{nnombre}</Text>
  </View> 



 </Page>
</Document>

);
 }


 
 pdfsnr(obj){

  let nnombre=this.props.obj.nombre+" "+this.props.obj.ap_paterno+" "+this.props.obj.ap_materno;
  var hoy = new Date();
  var hoy1 = new Date(this.props.obj.fecha_nac);

  var dd;
  
  if(hoy.getDate()<10){
    dd="0"+hoy.getDate();
  }else{
    dd= hoy.getDate();
  }
  
  var ms;
  
  if((hoy.getMonth()+1)<10){
    ms="0"+(hoy.getMonth()+1);
  }else{
    ms= (hoy.getMonth()+1);
  }
  
  var mm;
  if((hoy.getMonth()+1)==1){
  mm="Enero";
  }else if((hoy.getMonth()+1)==2){
    mm="Febrero";
  }else if((hoy.getMonth()+1)==3){
    mm="Marzo";
  }else if((hoy.getMonth()+1)==4){
    mm="Abril";
  }else if((hoy.getMonth()+1)==5){
    mm="Mayo";
  }else if((hoy.getMonth()+1)==6){
    mm="Junio";
  }else if((hoy.getMonth()+1)==7){
    mm="Julio";
  }else if((hoy.getMonth()+1)==8){
    mm="Agosto";
  }else if((hoy.getMonth()+1)==9){
    mm="Septiembre";
  }else if((hoy.getMonth()+1)==10){
    mm="Octubre";
  }else if((hoy.getMonth()+1)==11){
    mm="Noviembre";
  }else if((hoy.getMonth()+1)==12){
    mm="Diciembre";
  }

  var yyyy = hoy.getFullYear().toString()
  var yyyy2 = hoy1.getFullYear().toString()

  return  (
<Document >
<Page size={'LETTER'} style={{ backgroundImage:`url(${background2})`}}>
<View >
<Image
style={{
  position: 'absolute',
  height: '100vh',
  width: '100vw',
}}
      src={background2}
    />
</View>
<View style={{marginLeft:390,marginTop:175, flexDirection: 'row'}}>
 <Text style={{ fontSize:12}}>{dd}</Text>
 <Text style={{ fontSize:12,marginLeft:45}}>{mm}</Text>
   </View>



   <View style={{marginLeft:194,marginTop:316,alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text  fixed style={{ fontSize: nnombre.length >28 ? 10 : 12}}>{nnombre}</Text>
  </View> 

  <View style={{marginLeft:107,marginTop:336, flexDirection: 'row',alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text style={{ fontSize:this.state.calle.length > 19 ?10 : 12}}>{this.state.calle}</Text>
   </View>

   <View style={{marginLeft:300,marginTop:336, flexDirection: 'row',alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text style={{ fontSize:12}}>{this.state.numero}</Text>
   </View>

   <View style={{marginLeft:397,marginTop:336, flexDirection: 'row',alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text style={{ fontSize:this.state.colonia.length > 20 ? 10 : 12}}>{this.state.colonia}</Text>
   </View>

   <View style={{marginLeft:355,marginTop:358,alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text  fixed style={{ fontSize: 12}}>{this.props.obj.CURP}</Text>
  </View> 

  <View style={{marginLeft:160,marginTop:378,alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text  fixed style={{ fontSize: 12}}>{yyyy2}</Text>
  </View> 


 
  <View style={{marginLeft:205,marginTop:549,alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute'}}>
 <Text  fixed style={{ fontSize: nnombre.length >28 ? 10 : 12}}>{nnombre}</Text>
  </View> 



 </Page>
</Document>

);
 }


 pdfcs(obj){

  let nnombre=this.props.obj.nombre+" "+this.props.obj.ap_paterno+" "+this.props.obj.ap_materno;
    var hoy = new Date();
    var hoy1 = new Date(this.props.obj.fecha_nac);
  
    var dd;

    if(hoy.getDate()<10){
      dd="0"+hoy.getDate();
    }else{
      dd= hoy.getDate();
    }

    let nd;
    if (dd === '01') {
      nd = 'uno';
    } else if (dd === '02') {
      nd = 'dos';
    } else if (dd === '03') {
      nd = 'tres';
    } else if (dd === '04') {
      nd = 'cuatro';
    } else if (dd === '05') {
      nd = 'cinco';
    } else if (dd === '06') {
      nd = 'seis';
    } else if (dd === '07') {
      nd = 'siete';
    } else if (dd === '08') {
      nd = 'ocho';
    } else if (dd === '09') {
      nd = 'nueve';
    } else if (dd === '10') {
      nd = 'diez';
    } else if (dd === '11') {
      nd = 'once';
    } else if (dd === '12') {
      nd = 'doce';
    } else if (dd === '13') {
      nd = 'trece';
    } else if (dd === '14') {
      nd = 'catorce';
    } else if (dd === '15') {
      nd = 'quince';
    } else if (dd === '16') {
      nd = 'dieciséis';
    } else if (dd === '17') {
      nd = 'diecisiete';
    } else if (dd === '18') {
      nd = 'dieciocho';
    } else if (dd === '19') {
      nd = 'diecinueve';
    } else if (dd === '20') {
      nd = 'veinte';
    } else if (dd === '21') {
      nd = 'veintiuno';
    } else if (dd === '22') {
      nd = 'veintidós';
    } else if (dd === '23') {
      nd = 'veintitrés';
    } else if (dd === '24') {
      nd = 'veinticuatro';
    } else if (dd === '25') {
      nd = 'veinticinco';
    } else if (dd === '26') {
      nd = 'veintiséis';
    } else if (dd === '27') {
      nd = 'veintisiete';
    } else if (dd === '28') {
      nd = 'veintiocho';
    } else if (dd === '29') {
      nd = 'veintinueve';
    } else if (dd === '30') {
      nd = 'treinta';
    } else if (dd === '31') {
      nd = 'treinta y uno';
    }
    
    var ms;
    
    if((hoy.getMonth()+1)<10){
      ms="0"+(hoy.getMonth()+1);
    }else{
      ms= (hoy.getMonth()+1);
    }
    
    var mm;
    if((hoy.getMonth()+1)==1){
    mm="Enero";
    }else if((hoy.getMonth()+1)==2){
      mm="Febrero";
    }else if((hoy.getMonth()+1)==3){
      mm="Marzo";
    }else if((hoy.getMonth()+1)==4){
      mm="Abril";
    }else if((hoy.getMonth()+1)==5){
      mm="Mayo";
    }else if((hoy.getMonth()+1)==6){
      mm="Junio";
    }else if((hoy.getMonth()+1)==7){
      mm="Julio";
    }else if((hoy.getMonth()+1)==8){
      mm="Agosto";
    }else if((hoy.getMonth()+1)==9){
      mm="Septiembre";
    }else if((hoy.getMonth()+1)==10){
      mm="Octubre";
    }else if((hoy.getMonth()+1)==11){
      mm="Noviembre";
    }else if((hoy.getMonth()+1)==12){
      mm="Diciembre";
    }
  
    var yyyy = hoy.getFullYear().toString()
    var yyyy2 = hoy1.getFullYear().toString()
  
    return  (
  <Document >
  <Page size={'LETTER'} style={{ backgroundImage:`url(${background3})`}}>
  <View >
  <Image
  style={{
    position: 'absolute',
    height: '100vh',
    width: '100vw',
  }}
        src={background3}
      />
  </View>
 
  
  
     <View style={{marginLeft:110,marginTop:270,alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute',fontFamily:'Helvetica-Oblique'}}>
   <Text  fixed style={{ fontSize: 12,lineHeight:'1.5'}}>
   &nbsp; El suscrito <Text style={{fontFamily:'Helvetica-BoldOblique'}}>C. Jorge Alberto Contreras, Secretario del H. XLIII Ayuntamiento{"\n"} 
   Constitucional de Tepic, Nayarit;</Text> con fundamento al artículo 114 fracción V de la{"\n"}  
   Ley Municipal para el Estado de Nayarit, <Text style={{fontFamily:'Helvetica-BoldOblique'}}>Hace Constar</Text>, Que revisados los archivos{"\n"}  
   de esta junta municipal de reclutamiento, <Text style={{fontFamily:'Helvetica-BoldOblique'}}>Se Encontró Registro de Matricula </Text>del{"\n"} 
   <Text style={{fontFamily:'Helvetica-BoldOblique'}}>C. {nnombre},</Text> de la clase <Text style={{fontFamily:'Helvetica-BoldOblique'}}>“{this.props.obj.clase},</Text> Con de Matricula: <Text style={{fontFamily:'Helvetica-BoldOblique'}}>{"\n"} 
   {this.props.obj.matricula}".</Text></Text>
    </View> 



    <View style={{marginLeft:110,marginTop:410,alignItems:'flex-end',alignContent:'flex-end', justifyContent:'flex-end',position:'absolute',fontFamily:'Helvetica-Oblique'}}>
   <Text  fixed style={{ fontSize: 12, lineHeight:'1.5'}}>
   &nbsp; Se extiende la presente para los fines legales a que haya lugar, en la ciudad de{"\n"} 
   Tepic, capital del Estado de Nayarit; a los ({dd}) {nd} días del mes de {mm} del año{"\n"} 
   2026, dos mil veintiséis.</Text>
    </View> 
  
  
    
  
  
  
   </Page>
  </Document>
  
  );
   }
  
  
   fechaNombre(fecha){
    let fN=fecha.substring(0,10);
    let fnn="";
    
    let af=fN.split("-");
    
    fnn=af[2]+" DE ";
    
    if(af[1]=="01"){
      fnn=fnn+"ENERO DE "
    }else if(af[1]=="02"){
      fnn=fnn+"FEBRERO DE "
    }
    else if(af[1]=="03"){
      fnn=fnn+"MARZO DE "
    }
    else if(af[1]=="04"){
      fnn=fnn+"ABRIL DE "
    }
    else if(af[1]=="05"){
      fnn=fnn+"MAYO DE "
    }
    else if(af[1]=="06"){
      fnn=fnn+"JUNIO DE "
    }
    else if(af[1]=="07"){
      fnn=fnn+"JULIO DE "
    }
    else if(af[1]=="08"){
      fnn=fnn+"AGOSTO DE "
    }
    else if(af[1]=="09"){
      fnn=fnn+"SEPTIEMBRE DE "
    }
    else if(af[1]=="10"){
      fnn=fnn+"OCTUBRE DE "
    }
    else if(af[1]=="11"){
      fnn=fnn+"NOVIEMBRE DE "
    }
    else if(af[1]=="12"){
      fnn=fnn+"DICIEMBRE DE "
    }
    
    fnn=fnn+af[0];
    return fnn;
    }

   
   pdfcsnr(obj){
  

    const fechaActual = new Date();
    const añoActual = fechaActual.getFullYear();
    
   
    // Restar 18 años a la fecha actual
    const fechaHace18Años = new Date();
    fechaHace18Años.setFullYear(añoActual - 18);
    const añoHace18Años = fechaHace18Años.getFullYear();


    let nnombre=this.props.obj.nombre+" "+this.props.obj.ap_paterno+" "+this.props.obj.ap_materno;
    var hoy = new Date();
    var hoy1 = new Date(this.props.obj.fecha_nac);
  
    var dd;
    
    if(hoy.getDate()<10){
      dd="0"+hoy.getDate();
    }else{
      dd= hoy.getDate();
    }

    let nd;
    if (dd === '01') {
      nd = 'uno';
    } else if (dd === '02') {
      nd = 'dos';
    } else if (dd === '03') {
      nd = 'tres';
    } else if (dd === '04') {
      nd = 'cuatro';
    } else if (dd === '05') {
      nd = 'cinco';
    } else if (dd === '06') {
      nd = 'seis';
    } else if (dd === '07') {
      nd = 'siete';
    } else if (dd === '08') {
      nd = 'ocho';
    } else if (dd === '09') {
      nd = 'nueve';
    } else if (dd === '10') {
      nd = 'diez';
    } else if (dd === '11') {
      nd = 'once';
    } else if (dd === '12') {
      nd = 'doce';
    } else if (dd === '13') {
      nd = 'trece';
    } else if (dd === '14') {
      nd = 'catorce';
    } else if (dd === '15') {
      nd = 'quince';
    } else if (dd === '16') {
      nd = 'dieciséis';
    } else if (dd === '17') {
      nd = 'diecisiete';
    } else if (dd === '18') {
      nd = 'dieciocho';
    } else if (dd === '19') {
      nd = 'diecinueve';
    } else if (dd === '20') {
      nd = 'veinte';
    } else if (dd === '21') {
      nd = 'veintiuno';
    } else if (dd === '22') {
      nd = 'veintidós';
    } else if (dd === '23') {
      nd = 'veintitrés';
    } else if (dd === '24') {
      nd = 'veinticuatro';
    } else if (dd === '25') {
      nd = 'veinticinco';
    } else if (dd === '26') {
      nd = 'veintiséis';
    } else if (dd === '27') {
      nd = 'veintisiete';
    } else if (dd === '28') {
      nd = 'veintiocho';
    } else if (dd === '29') {
      nd = 'veintinueve';
    } else if (dd === '30') {
      nd = 'treinta';
    } else if (dd === '31') {
      nd = 'treinta y uno';
    }
    
    var ms;
    
    if((hoy.getMonth()+1)<10){
      ms="0"+(hoy.getMonth()+1);
    }else{
      ms= (hoy.getMonth()+1);
    }
    
    var mm;
    if((hoy.getMonth()+1)==1){
    mm="Enero";
    }else if((hoy.getMonth()+1)==2){
      mm="Febrero";
    }else if((hoy.getMonth()+1)==3){
      mm="Marzo";
    }else if((hoy.getMonth()+1)==4){
      mm="Abril";
    }else if((hoy.getMonth()+1)==5){
      mm="Mayo";
    }else if((hoy.getMonth()+1)==6){
      mm="Junio";
    }else if((hoy.getMonth()+1)==7){
      mm="Julio";
    }else if((hoy.getMonth()+1)==8){
      mm="Agosto";
    }else if((hoy.getMonth()+1)==9){
      mm="Septiembre";
    }else if((hoy.getMonth()+1)==10){
      mm="Octubre";
    }else if((hoy.getMonth()+1)==11){
      mm="Noviembre";
    }else if((hoy.getMonth()+1)==12){
      mm="Diciembre";
    }
  
    var yyyy = hoy.getFullYear().toString()
    var yyyy2 = hoy1.getFullYear().toString()
  
    return  (
  <Document >
  <Page size={'LETTER'} style={{ backgroundImage:`url(${background4})`}}>
  <View >
  <Image
  style={{
    position: 'absolute',
    height: '100vh',
    width: '100vw',
  }}
        src={background4}
      />
  </View>



  <View style={{marginLeft:110,marginTop:236,marginRight:70,textAlign:'justify',position:'absolute'}}>
   <Text  fixed style={{ fontSize: 13,lineHeight:'1.3',fontFamily:'Helvetica-Oblique'}}>
   &nbsp;&nbsp;&nbsp;El suscrito <Text style={{fontFamily:'Helvetica-BoldOblique'}}>C. Jorge Alberto Contreras, Secretario del H. XLIII {"\n"}
   Ayuntamiento Constitucional de Tepic, Nayarit;</Text> con fundamento al {"\n"}
   artículo 114 fracción V de la Ley Municipal para el Estado de Nayarit, {"\n"}
   hace:       </Text>
    </View> 

    <View style={{marginLeft:110,marginTop:376,marginRight:70,textAlign:'justify',position:'absolute'}}>
   <Text  fixed style={{ fontSize: 13,lineHeight:'1.3',fontFamily:'Helvetica-Oblique'}}>
   &nbsp;&nbsp;&nbsp;Que, revisados los archivos de esta junta municipal de 
   reclutamiento, <Text style={{fontFamily:'Helvetica-BoldOblique'}}>No se Encontró Registro de Matricula</Text> del <Text style={{fontFamily:'Helvetica-BoldOblique'}}>C. {nnombre},
   </Text> en el servicio militar nacional de la clase "{this.props.obj.fecha_nac!= undefined ? this.props.obj.fecha_nac.substring(0,4) : this.props.obj.clase}"
    a la actual "{añoHace18Años}".</Text>
    </View> 
  

    <View style={{marginLeft:110,marginTop:460,marginRight:70,textAlign:'justify',position:'absolute'}}>
   <Text  fixed style={{ fontSize: 13,lineHeight:'1.3',fontFamily:'Helvetica-Oblique'}}>
   &nbsp;&nbsp;&nbsp;Se extiende la presente para los fines legales a que haya lugar, en {"\n"} 
   la ciudad de Tepic, capital del Estado de Nayarit; a los ({dd}) {nd} días {"\n"}  
   del mes de {mm} del año 2026, dos mil veintiséis.</Text>
    </View> 
  

  
   </Page>
  </Document>
  
  );
   }



   pdf2(obj){


    let dom='';
    if(obj.domicilio!=undefined){
      dom=obj.domicilio;
    }
    const capitalizeFirstLetter = (cadena) =>
      cadena
        ? cadena
            .toLowerCase()
            .split(' ')
            .map((palabra) => palabra.charAt(0).toUpperCase() + palabra.slice(1))
            .join(' ')
        : '';
    let nnombre=obj.nombre+" "+obj.ap_paterno+" "+obj.ap_materno;
    let nfn =this.fechaNombre(obj.fecha_nac);
    let nfe =capitalizeFirstLetter(this.fechaNombre(obj.fecha_entrega).replace(/\s?DE\s?/g, ' '));
    return  (
  <Document >
   <Page size={{width:312,height:425}} >

{
/*
   <View >
  <Image
  style={{
    position: 'absolute',
    height: '100vh',
    width: '100vw',
  }}
        src={formato2}
      />
  </View>
*/
}
<View  style={{ marginTop:(0+Number(this.state.MargenT)), marginLeft:(0+Number(this.state.MargenH)) }}>
   <View  style={{ marginLeft:161,marginTop:52}}>
  
  <Text style={{  fontSize:9}}>{obj.clase}</Text>
  </View>   
   <View  style={{ marginLeft:(70+Number(this.state.Margen)),marginTop:3}}>
  
   <Text style={{  fontSize: 9}}>{nnombre}</Text>
   </View>   
   <View  style={{marginLeft:145,marginTop:4}}>
   <Text style={{ fontSize:9}}>{nfn}</Text>
     </View>
  
     < View style={{marginLeft:85,marginTop:5}}>
   <Text fixed style={{ fontSize:9}}>{obj.lugar_nac}</Text>
     </View>
  
     <View style={{marginLeft:85,marginTop:dom.length> 45 ? 4 : 7}}>
   <Text fixed style={{ fontSize:9}}>{obj.nombre_padre}</Text>
     </View>
  
     <View style={{marginLeft:85,marginTop:5}}>
   <Text fixed style={{ fontSize:9}}>{obj.nombre_madre}</Text>
     </View>
     <View style={{marginLeft:130,marginTop: dom.length> 45 ? 5 : 7}}>
   <Text fixed  style={{ fontSize:9}}>{obj.estado_civil}</Text>
     </View>
     <View  style={{marginLeft:130,marginTop:5}}>
   <Text fixed style={{ fontSize:9}}>{obj.ocupacion}</Text>
     </View>
     <View style={{marginLeft:154,marginTop:5, flexDirection: 'row'}}>
   <Text fixed style={{ fontSize:9}}>{obj.leer_escribir}</Text>
   <Text fixed style={{ fontSize:8,marginLeft:37}}>{obj.CURP}</Text>
     </View>
     <View style={{marginLeft:167,marginTop:5}}>
   <Text fixed style={{ fontSize:9}}>{obj.grado+" "+obj.nivel_estudios}</Text>
     </View>
     <View style={{marginLeft:85,marginTop:4}}>
   <Text  fixed style={{ fontSize: obj.domicilio.length>45 ? 8 : 9}}>{obj.domicilio}</Text>
    </View> 
    <View style={{marginLeft:17,marginTop:85}}>
   <Text  fixed style={{ fontSize:7}}>{obj.presidente}</Text>
    </View> </View>
    <View style={{marginLeft:87,marginBottom:128,marginTop:16}}>
   <Text  fixed style={{ fontSize: 8}}>{" TEPIC, NAYARIT "+nfe}</Text>
    </View> 
    
   </Page>
  </Document>
  
  );
   }
  
   pdf(obj){
    const capitalizeFirstLetter = (cadena) =>
      cadena
        ? cadena
            .toLowerCase()
            .split(' ')
            .map((palabra) => palabra.charAt(0).toUpperCase() + palabra.slice(1))
            .join(' ')
        : '';
    let nnombre=obj.nombre+" "+obj.ap_paterno+" "+obj.ap_materno;

        let nfn =this.fechaNombre(obj.fecha_nac);
    let nfe =capitalizeFirstLetter(this.fechaNombre(obj.fecha_entrega).replace(/\s?DE\s?/g, ' '));
    return  (
  <Document >
   <Page size={{width:397,height:567}} >


  {
/*
   <View >
  <Image
  style={{
    position: 'absolute',
    height: '100vh',
    width: '100vw',
  }}
        src={formato1}
      />
  </View>
  */
  }
   <View  style={{ marginTop:(0+Number(this.state.MargenT)), marginLeft:(0+Number(this.state.MargenH)) }}>
   <View  style={{ marginLeft:187,marginTop:27}}>
   <Text style={{  fontSize:9,marginTop:37}}>{obj.clase}</Text>
  
   </View>   
   <View  style={{marginLeft:(69+Number(this.state.Margen)),marginTop: 32}}>
   <Text style={{  fontSize: 9}}>{nnombre}</Text>
     </View>
  
     < View style={{marginLeft:149,marginTop:0}}>
     <Text style={{ fontSize:9}}>{nfn}</Text>
  
     </View>
  
     <View style={{marginLeft:69,marginTop:4}}>
     <Text fixed style={{ fontSize:9}}>{obj.lugar_nac}</Text>
   
     </View>
  
     <View style={{marginLeft:69,marginTop:1}}>
     <Text fixed style={{ fontSize:9}}>{obj.nombre_padre}</Text>
  
     </View>
     <View style={{marginLeft:53,marginTop:1}}>
   <Text fixed style={{ fontSize:9}}>{obj.nombre_madre}</Text>
     </View>
  
     <View style={{marginLeft:27,marginTop:12}}>
     <Text fixed  style={{ fontSize:9}}>{obj.tutor==null || obj.tutor=='' ? <Text  style={{color:'transparent'}}>AAAAAAA</Text>: obj.tutor }</Text>
  
     </View>
     <View fixed style={{marginLeft:94,marginTop:2}}>
     <Text fixed  style={{ fontSize:9}}>{obj.estado_civil}</Text>
  
     </View>
     <View style={{marginLeft:269,marginTop:2, flexDirection: 'row'}}>
     <Text fixed style={{ fontSize:9}}>{obj.ocupacion}</Text>
   
  
     </View>
     <View style={{marginLeft:160,marginTop:2}}>
     <Text fixed style={{ fontSize:9}}>{obj.leer_escribir}</Text>
  
     </View>
     <View style={{marginLeft:170,marginTop:1}}>
     <Text fixed style={{ fontSize:9}}>{obj.grado+" "+obj.nivel_estudios}</Text>
  
    </View> 
    <View style={{marginLeft:80,marginTop:5}}>
    <Text  fixed style={{ fontSize:9}}>{obj.domicilio}</Text>
  
    </View> 
    <View style={{marginLeft:100,marginTop:44}}>
   <Text  fixed style={{ fontSize: 9}}>{" TEPIC, NAYARIT "+nfe}</Text>
    </View> 

    </View>
   </Page>
  </Document>
  
  );
   }


   pdf3(obj){
    const capitalizeFirstLetter = (cadena) =>
      cadena
        ? cadena
            .toLowerCase()
            .split(' ')
            .map((palabra) => palabra.charAt(0).toUpperCase() + palabra.slice(1))
            .join(' ')
        : '';
    let nnombre=obj.nombre+" "+obj.ap_paterno+" "+obj.ap_materno;

        let nfn =this.fechaNombre(obj.fecha_nac);
    let nfe =capitalizeFirstLetter(this.fechaNombre(obj.fecha_entrega).replace(/\s?DE\s?/g, ' '));
    return  (
  <Document >
   <Page size={{width:397,height:567}} >


  {
/*
   <View >
  <Image
  style={{
    position: 'absolute',
    height: '100vh',
    width: '100vw',
  }}
        src={formato1}
      />
  </View>
  */
  }
   <View  style={{ marginTop:(0+Number(this.state.MargenT)), marginLeft:(0+Number(this.state.MargenH)) }}>
   <View  style={{ marginLeft:184,marginTop:62}}>
   <Text style={{  fontSize:12,marginTop:34}}>{obj.clase}</Text>
  
   </View>   
   <View  style={{marginLeft:30,marginTop:nnombre.length>=32 ? 36 : 34}}>
   <Text style={{  fontSize:nnombre.length>=32 ? 9 : 12}}>{nnombre}</Text>
     </View>
  
     < View style={{marginLeft:129,marginTop:0}}>
     <Text style={{ fontSize:12}}>{obj.nfecha_nac}</Text>
  
     </View>
  
     <View style={{marginLeft:40,marginTop:4}}>
     <Text fixed style={{ fontSize:12}}>{obj.lugar_nac}</Text>
   
     </View>
  
     <View style={{marginLeft:45,marginTop:1}}>
     <Text fixed style={{ fontSize:12}}>{obj.nombre_padre}</Text>
  
     </View>
     <View style={{marginLeft:25,marginTop:2}}>
   <Text fixed style={{ fontSize:12}}>{obj.nombre_madre}</Text>
     </View>
  
     <View style={{marginLeft:7,marginTop:17}}>
     <Text fixed  style={{ fontSize:12}}>{obj.tutor==null || obj.tutor=='' ? <Text  style={{color:'transparent'}}>AAAAAAA</Text>: obj.tutor }</Text>
  
     </View>
     <View fixed style={{marginLeft:80,marginTop:2}}>
     <Text fixed  style={{ fontSize:12}}>{obj.estado_civil}</Text>
  
     </View>
     <View style={{marginLeft:269,marginTop:2, flexDirection: 'row'}}>
     <Text fixed style={{ fontSize:12}}>{obj.ocupacion}</Text>
   
  
     </View>
     <View style={{marginLeft:160,marginTop:2}}>
     <Text fixed style={{ fontSize:12}}>{obj.leer_escribir}</Text>
  
     </View>
     <View style={{marginLeft:170,marginTop:1}}>
     <Text fixed style={{ fontSize:12}}>{obj.grado+" "+obj.nivel_estudios}</Text>
  
    </View> 
    <View style={{marginLeft:60,marginTop:4}}>
    <Text  fixed style={{ fontSize:12}}>{obj.domicilio}</Text>
  
    </View> 
    <View style={{marginLeft:85,marginTop:60}}>
   <Text  fixed style={{ fontSize: 12}}>{obj.lugar_nac+"   "+obj.nfecha_entrega}</Text>
    </View> 
    </View>
   </Page>
  </Document>
  
  );
   }


   /*
      pdf(obj){
    const capitalizeFirstLetter = (cadena) =>
      cadena
        ? cadena
            .toLowerCase()
            .split(' ')
            .map((palabra) => palabra.charAt(0).toUpperCase() + palabra.slice(1))
            .join(' ')
        : '';
    let nnombre=obj.nombre+" "+obj.ap_paterno+" "+obj.ap_materno;

        let nfn =this.fechaNombre(obj.fecha_nac);
    let nfe =capitalizeFirstLetter(this.fechaNombre(obj.fecha_entrega).replace(/\s?DE\s?/g, ' '));
    return  (
  <Document >
   <Page size={{width:397,height:567}} >


  {

   <View >
  <Image
  style={{
    position: 'absolute',
    height: '100vh',
    width: '100vw',
  }}
        src={formato1}
      />
  </View>
  
  }

   <View  style={{ marginLeft:184,marginTop:62}}>
   <Text style={{  fontSize:12,marginTop:34}}>{obj.clase}</Text>
  
   </View>   
   <View  style={{marginLeft:(30+Number(this.state.Margen)),marginTop: 34}}>
   <Text style={{  fontSize: 12}}>{nnombre}</Text>
     </View>
  
     < View style={{marginLeft:129,marginTop:0}}>
     <Text style={{ fontSize:12}}>{nfn}</Text>
  
     </View>
  
     <View style={{marginLeft:40,marginTop:4}}>
     <Text fixed style={{ fontSize:12}}>{obj.lugar_nac}</Text>
   
     </View>
  
     <View style={{marginLeft:45,marginTop:1}}>
     <Text fixed style={{ fontSize:12}}>{obj.nombre_padre}</Text>
  
     </View>
     <View style={{marginLeft:25,marginTop:2}}>
   <Text fixed style={{ fontSize:12}}>{obj.nombre_madre}</Text>
     </View>
  
     <View style={{marginLeft:7,marginTop:17}}>
     <Text fixed  style={{ fontSize:12}}>{obj.tutor==null || obj.tutor=='' ? <Text  style={{color:'transparent'}}>AAAAAAA</Text>: obj.tutor }</Text>
  
     </View>
     <View fixed style={{marginLeft:80,marginTop:2}}>
     <Text fixed  style={{ fontSize:12}}>{obj.estado_civil}</Text>
  
     </View>
     <View style={{marginLeft:269,marginTop:2, flexDirection: 'row'}}>
     <Text fixed style={{ fontSize:12}}>{obj.ocupacion}</Text>
   
  
     </View>
     <View style={{marginLeft:160,marginTop:2}}>
     <Text fixed style={{ fontSize:12}}>{obj.leer_escribir}</Text>
  
     </View>
     <View style={{marginLeft:170,marginTop:1}}>
     <Text fixed style={{ fontSize:12}}>{obj.grado+" "+obj.nivel_estudios}</Text>
  
    </View> 
    <View style={{marginLeft:60,marginTop:4}}>
    <Text  fixed style={{ fontSize:12}}>{obj.domicilio}</Text>
  
    </View> 
    <View style={{marginLeft:85,marginTop:60}}>
   <Text  fixed style={{ fontSize: 12}}>{" TEPIC, NAYARIT "+nfe}</Text>
    </View> 
   </Page>
  </Document>
  
  );
   }
   */
  render() {


    const  usuario = this.props.obj.UsuarioRegistra
let respuesta;
    if(this.props.user!=453 && this.props.user!=454 && this.props.user!=455){
      respuesta =  <Dropdown.Item eventKey="4" onClick={this.handleShow4}>3 - Respuesta</Dropdown.Item>

      if(this.props.index==4){
        respuesta="";
      }
    }

    let turnar;
    let refrendo;
    if(this.props.user==453 && (this.props.index!=1 || this.props.index!=2 )
     ){

      if(this.props.index==0){
       let df=this.faltantes();

      if(df=="" && this.props.index==0){
        if(this.props.obj.giros!=null || this.props.obj.giros!=''){
        turnar = <Dropdown.Item eventKey="1" onClick={this.handleShow}>3 - Turnar</Dropdown.Item>
        }
        }
      }

        if(this.props.index==3 || this.props.index==4 || this.props.index==2){

   
          turnar = <Dropdown.Item eventKey="1" onClick={this.handleShowCN}>4 - Returnar-Revision</Dropdown.Item>
         }

         if(this.props.index==5){

   
          refrendo = <Dropdown.Item eventKey="8" onClick={this.handleShowCN2}>6 - Refrendo</Dropdown.Item>
         }
    }

    let detalle;
    if(this.props.user==453 || this.props.user==454
     ){
      detalle = <Dropdown.Item eventKey="2" onClick={this.handleShow2}>1 - DETALLE</Dropdown.Item>
    }else if(this.props.user==455){
      detalle = <Dropdown.Item eventKey="2" onClick={this.handleShow2_2}>1 - DETALLE</Dropdown.Item>
    }else if(this.props.user!=453 && this.props.user!=454){
      detalle = <Dropdown.Item eventKey="2" onClick={this.handleShow2_1}>1 - DETALLE</Dropdown.Item>
    }
    

    let licencia;
    
    if(this.props.user==453 && (this.props.index!=0 && this.props.index!=5 )
     ){
      licencia = <Dropdown.Item eventKey="5" onClick={this.handleShow5}>5 - Licencia</Dropdown.Item>
    }


    let cancelado;
    
    if(this.props.user==453 && (this.props.index!=5 && this.props.index!=6 )
     ){
      cancelado = <Dropdown.Item eventKey="11" onClick={this.handleShowCancelado}>-CANCELAR-</Dropdown.Item>
    }

    let descancelado;
    
    if(this.props.user==453 && ( this.props.index==6 )
     ){
      descancelado = <Dropdown.Item eventKey="12" onClick={this.handleShowDesCancelado}>-Estatus-</Dropdown.Item>
    }

    let imprimir;
    if(( this.props.user==449 ) ){
      imprimir =  <Dropdown.Item eventKey="6" onClick={this.handleShow6}>Imprimir</Dropdown.Item>
    }
    

    let inspeccionDGDUE;
    if(( this.props.user==448 || this.props.user==450 ) ){
      inspeccionDGDUE =  <Dropdown.Item eventKey="7" onClick={this.handleShow7}>Inspección</Dropdown.Item>
    }
     if(this.props.user==452){
      inspeccionDGDUE =  <Dropdown.Item eventKey="7" onClick={this.handleShow8}>Inspección</Dropdown.Item>

    }
    if(this.props.user==458){
      inspeccionDGDUE =  <Dropdown.Item eventKey="7" onClick={this.handleShow8}>Inspección</Dropdown.Item>

    }
    if(this.props.user==451){
      inspeccionDGDUE =  <Dropdown.Item eventKey="7" onClick={this.handleShow82}>Inspección</Dropdown.Item>

    }

 
    let formatoPC;
    if(( this.props.user==451 ) ){
      formatoPC =  <Dropdown.Item eventKey="10" onClick={this.handleShowFPC}>Formato Dictamen-PC</Dropdown.Item>
    }

    let formatoCU;
    if(( this.props.user==451 ) ){
      formatoCU =  <Dropdown.Item eventKey="10" onClick={this.handleShowFCU}>Formato Dictmaen-CU</Dropdown.Item>
    }

{/* 
    if(this.props.user==453
      ){
       detalle = <Dropdown.Item eventKey="2"> <Link
       to={{
         pathname: "/dideco/detalle",
         state: { id_oficio: this.props.obj.id_oficio }
       }}
       >DETALLE</Link></Dropdown.Item>

     }else if(this.props.user!=453){
       detalle = <Dropdown.Item eventKey="2"> <Link
    to={{
      pathname: "/dideco/detalle2",
      state: { id_oficio: this.props.obj.id_oficio }
    }}
    >DETALLE</Link></Dropdown.Item>
     }
   */} 

    let color;
    if (this.props.obj.usuarioSeguimiento==448){
      color= <td style={{ textAlign: 'center'}} bgcolor="#c0ccb5" onClick={()=>{this.setState({show3:true})}}>{this.props.obj.usrSeguimiento}</td>
    }else if(this.props.obj.usuarioSeguimiento==449){
      color= <td style={{ textAlign: 'center'}} bgcolor="#fefcc4" onClick={()=>{this.setState({show3:true})}}> {this.props.obj.usrSeguimiento}</td>
    }else if (this.props.obj.usuarioSeguimiento==450){
      color= <td style={{ textAlign: 'center'}} bgcolor="#e0f7ca" onClick={()=>{this.setState({show3:true})}}>{this.props.obj.usrSeguimiento}</td>
    }else if (this.props.obj.usuarioSeguimiento==451){
      color= <td style={{ textAlign: 'center'}} bgcolor="#f9d6d1" onClick={()=>{this.setState({show3:true})}}>{this.props.obj.usrSeguimiento}</td>
    }else if (this.props.obj.usuarioSeguimiento==452){
      color= <td style={{ textAlign: 'center'}} bgcolor="#c6ecfc" onClick={()=>{this.setState({show3:true})}}>{this.props.obj.usrSeguimiento}</td>
    }else if (this.props.obj.usuarioSeguimiento==458){
      color= <td style={{ textAlign: 'center'}} bgcolor="#c6c2c2" onClick={()=>{this.setState({show3:true})}}>Aseo Público</td>
    }else if (this.props.obj.usuarioSeguimiento==453){
      color= <td style={{ textAlign: 'center'}} bgcolor="#d5d5d5" onClick={()=>{this.setState({show3:true})}}>{this.props.obj.usrSeguimiento}</td>
    }
    

    let fechatur;
    if(this.props.obj.fecha_turnado_direccion == null || this.props.obj.fecha_turnado_direccion== ""){
      fechatur= <td style={{ textAlign: 'center'}} >"0000-00-00"</td>
      
    }
    else{

      fechatur= <td style={{ textAlign: 'center'}}>{this.props.obj.fecha_turnado_direccion.substring(8,10)+"/"+this.props.obj.fecha_turnado_direccion.substring(5,7)+"/"+this.props.obj.fecha_turnado_direccion.substring(0,4)}</td>
    }

    let fecha;
    if(this.props.obj.fecha_termino == null || this.props.obj.fecha_termino == ""){
      fecha= <td style={{ textAlign: 'center'}}>"0000-00-00"</td>
      
    }
    else{

      var f = new Date();
      let yr=f.getFullYear();
      let ms="";
      let da="";
      if((f.getMonth() +1)<10){
        ms="0"+(f.getMonth() +1)
      }else{
        ms=(f.getMonth() +1)
      }
      if(f.getDate()<10){
        da="0"+f.getDate()
      }else{
        da=f.getDate()
      }
      let date1 =(yr+"-"+ms+"-"+da);
        var date2 = new Date(this.props.obj.fecha_termino.substring(0,10));

        if(date2>=f){
          fecha= <td style={{ textAlign: 'center'}} bgcolor="#c1f4b2"><font>{this.props.obj.fecha_termino.substring(8,10)+"/"+this.props.obj.fecha_termino.substring(5,7)+"/"+this.props.obj.fecha_termino.substring(0,4)}</font></td>
        }else if(date1==this.props.obj.fecha_termino){
          fecha= <td style={{ textAlign: 'center'}} bgcolor="#ead4a8">{this.props.obj.fecha_termino.substring(8,10)+"/"+this.props.obj.fecha_termino.substring(5,7)+"/"+this.props.obj.fecha_termino.substring(0,4)}</td>
        }
        else{
          fecha= <td style={{ textAlign: 'center'}} bgcolor="#f4b2b2">{this.props.obj.fecha_termino.substring(8,10)+"/"+this.props.obj.fecha_termino.substring(5,7)+"/"+this.props.obj.fecha_termino.substring(0,4)}</td>
        }
      
     
    }


    //fasttrack
    let giro;
    if((this.props.obj.fast_track=="S" && this.props.obj.BMR==null) || (this.props.obj.BMR==101 && this.props.obj.fast_track=='N') || (this.props.obj.BMR==101 && this.props.obj.fast_track=='S')){
      giro= <td style={{ textAlign: 'center'}} bgcolor="#eac90e" >{this.props.obj.giros}</td>
    }else if(this.props.obj.BMR==102){
      giro= <td style={{ textAlign: 'center'}} bgcolor="#e89110" >{this.props.obj.giros}</td>
    }
    else if(this.props.obj.BMR==103){
      giro= <td style={{ textAlign: 'center'}} bgcolor="#eac90e" >{this.props.obj.giros}</td>
    }
    else{
      giro= <td style={{ textAlign: 'center'}}>{this.props.obj.giros}</td>
    }

    let pers;
    if(this.props.obj.persona_fm=="F"){
   pers=<h3 align="center">Persona Fisica </h3>;
    }else if(this.props.obj.persona_fm=="M"){
      pers=<h3 align="center">Persona Moral </h3>;
    }
    
   

    let vinculado;
    
    if(((this.props.tipo==1 && this.props.index==0) || ((this.props.tipo==1 && this.props.index==7))) && this.props.obj.vinculado!="S"){
      vinculado = <Dropdown.Item eventKey="2" onClick={this.handleShowCN2}>VALIDAR</Dropdown.Item>
    }


    let vin2;
    
    if(this.props.tipo==1 && this.props.index>0){
      vin2 = <Dropdown.Item eventKey="2" onClick={this.handleShow4}>CARTILLA</Dropdown.Item>
    }

    let c1;
    
    if(this.props.tipo==1 && this.props.index>0){
      c1 = <Dropdown.Item eventKey="2" onClick={this.handleShowDesCancelado}>FORMATOS</Dropdown.Item>
    }


    let c2;
    
    if(this.props.tipo==1 && this.props.index>0){
     // c2 = <Dropdown.Item eventKey="2" onClick={this.handleShowCN}>Formato 2</Dropdown.Item>
    }

    let aa;
    
    if(this.props.tipo==2 && this.props.index!=1){
      aa = <Dropdown.Item eventKey="2" onClick={this.handleShow5}>CONSTANCIAS</Dropdown.Item>
    }
    
    let req;
    
    if(this.props.tipo==1 && this.props.index==1){
      req =<Dropdown.Item eventKey="4" onClick={this.handleShow2_1} >REQUISITOS</Dropdown.Item>

    }

    let reqp;
    
    if(this.props.tipo==1 && this.props.index==2){
      reqp =<Dropdown.Item eventKey="4" onClick={this.handleShow2_2} >REQUISITOS</Dropdown.Item>

    }


    let empaquetado;
    
    if(this.props.tipo==1 && this.props.index==3){
      empaquetado =<Dropdown.Item eventKey="4" onClick={this.handleShow3} >EMPAQUETAR</Dropdown.Item>

    }else if(this.props.tipo==2 && this.props.index==1){
      empaquetado =<Dropdown.Item eventKey="4" onClick={this.handleShow3} >PARA ENTREGAR</Dropdown.Item>

    }else if(this.props.tipo==1 && this.props.index==5){
      empaquetado =<Dropdown.Item eventKey="4" onClick={this.handleShow3} >ENTREGAR</Dropdown.Item>

    }


    let CANCELAR;
    
    if(this.props.tipo==1 && (this.props.index==2 || this.props.index==3)){
      CANCELAR =<Dropdown.Item eventKey="4" onClick={this.handleShow6} >CANCELAR</Dropdown.Item>
    }



    let enr;
    
    if(this.props.tipo==2 && this.props.index==2){
      enr =<Dropdown.Item eventKey="4" onClick={()=>{
        this.handleShow7();
        this.setState({
          ap_paterno:this.props.obj.ap_paterno,
          ap_materno:this.props.obj.ap_materno,
          nombre:this.props.obj.nombre,
          CURP:this.props.obj.CURP,
          clase:this.props.obj.clase,
          domicilio:this.props.obj.domicilio,
          telefono:this.props.obj.telefono,
        });
      }} >EDITAR</Dropdown.Item>
    }


    const fechaConIntl = new Intl.DateTimeFormat('es-CL', {
      dateStyle: 'short',
      timeStyle: 'long',
      timeZone: 'America/Santiago',
  });
    return (
        <tr >
           {(this.props.tipo==1 && this.props.index==7) ? <td><center>
            {this.props.obj.Estatus==null ? "Preregistrado" : this.props.obj.Estatus}
            </center> </td> : null} 
          {(this.props.tipo==1 && this.props.index!=0) || (this.props.tipo==2 && this.props.index!=2)? <td style={{backgroundColor:this.props.obj.id_estatus==7 ? '#ba3535' : ''}}><center>
            {this.props.obj.matricula}
            </center> </td> : null}  

            {this.props.tipo==2 && this.props.index==2 ? 
            
            
            [<td  >
              <center> {this.props.obj.ap_paterno}</center>
              </td>,
              <td  >
              <center> {this.props.obj.ap_materno}</center>
              </td>,
              <td  >
              <center> {this.props.obj.nombre}</center>
              </td>,
              <td >
              <center>{this.props.obj.CURP}</center>
              </td>,
              <td >
              <center>{this.props.obj.clase}</center>
              </td>,
              <td>
              <center> {this.props.obj.telefono}</center>
              </td>,
    
              <td>
              <center>{this.props.obj.fecha_reg.substring(0,10).replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1')} {}</center>
              </td>]
                
            
            : 
            
            
            [<td  >
          <center> {this.props.obj.ap_paterno}</center>
          </td>,
          <td  >
          <center> {this.props.obj.ap_materno}</center>
          </td>,
          <td  >
          <center> {this.props.obj.nombre}</center>
          </td>,
          <td >
          <center>{this.props.obj.fecha_nac.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1')}</center>
          </td>,
          <td >
          <center>{this.props.obj.estado_civil}</center>
          </td>,
          <td>
          <center> {this.props.obj.ocupacion}</center>
          </td>,

          <td>
          <center>{this.props.obj.fecha_reg.substring(0,10).replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1')} {}</center>
          </td>]
            
            
            }  
         
        
        

          <td style={{ alignContent: 'center', paddingLeft:20}}> 
        <center>
				
		
          <DropdownButton
            title={''}
      
            variant={'secondary'}
            id={`dropdown-button-drop-right`}
            key={'Info'}
            drop={'end'}
            style={{ margin: 3 ,alignContent:'center',borderRadius:'40px'}}
            disabled={this.state.btnOn}
          
          >
            
         
            
            
      
                    {vinculado}
                    {vin2}
                      {req}
                      {reqp}
                      {empaquetado}
                      {aa}

                  
           {this.props.tipo==2 && this.props.index==2 ? null : <Dropdown.Item eventKey="3" onClick={this.handleShow2} >DETALLE</Dropdown.Item>}
            {c1}
           {CANCELAR}
           {enr}
          </DropdownButton>
        
          </center>
       
          </td>

         
          <>
      

        <Modal size='xl' centered show={this.state.show} onHide={this.handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>FORMATO 2</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.show==true ?   [<div style={{height:700}}><PDFViewer width={'100%'} height={'100%'} showToolbar={true}>
    {this.pdf2(this.props.obj)}
  </PDFViewer></div>,<PDFDownloadLink document={this.pdf2(this.props.obj)} fileName={"cartilla_f2-"+this.props.obj.matricula+".pdf"} >
      {({ blob, url, loading, error }) => (loading ? 'Loading document...' :  <Button  variant="outlined" color="primary" >Descargar</Button>)}
    </PDFDownloadLink>]: null}
          </Modal.Body>
         
        </Modal>
      </>

      <>
      

        <Modal size='xl' centered show={this.state.showCN} onHide={this.handleCloseCN}>
        <Modal.Header closeButton>
            <Modal.Title>FORMATO 1</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.showCN==true ? [<div style={{height:700}}><PDFViewer width={'100%'} height={'100%'} showToolbar={true}>
    {this.pdf(this.props.obj)}
  </PDFViewer></div>,<PDFDownloadLink document={this.pdf(this.props.obj)} fileName={"cartilla_f1-"+this.props.obj.matricula+".pdf"} >
      {({ blob, url, loading, error }) => (loading ? 'Loading document...' :  <Button  variant="outlined" color="primary" >Descargar</Button>)}
    </PDFDownloadLink>]: null}
         </Modal.Body>
         
        </Modal>
      </>


      
      <>
      

        <Modal size='xl' centered show={this.state.showCNa} onHide={this.handleCloseCNa}>
        <Modal.Header closeButton>
            <Modal.Title>FORMATO 1 v1</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.showCNa==true ? [<div style={{height:700}}><PDFViewer width={'100%'} height={'100%'} showToolbar={true}>
    {this.pdf3(this.props.obj)}
  </PDFViewer></div>,<PDFDownloadLink document={this.pdf3(this.props.obj)} fileName={"cartilla_f3-"+this.props.obj.matricula+".pdf"} >
      {({ blob, url, loading, error }) => (loading ? 'Loading document...' :  <Button  variant="outlined" color="primary" >Descargar</Button>)}
    </PDFDownloadLink>]: null}
         </Modal.Body>
         
        </Modal>
      </>
      <>
      

      <Modal 
      radius="40px"
      size='lg' centered show={this.state.showCN2} onHide={this.handleCloseCN2}>
        <Modal.Header closeButton>
          <Modal.Title style={{fontSize:'17px',color:'#1D2630',padding:'10px 17px'}}>VALIDAR INFORMACIÓN</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <RegistroOficio2 obj={this.props.obj}
       onR={this.props.onR}
       id_usuario={this.props.id_usuario}
        />
       </Modal.Body>
      
      </Modal>
    </>
    <>
      

      <Modal size="xl" centered show={this.state.show2} onHide={this.handleClose2} style={{marginTop:40}}>
        <Modal.Header closeButton>
          <Modal.Title>DETALLE </Modal.Title>
        </Modal.Header>
        <Modal.Body><DatosOficio obj={this.props.obj}
       onR={this.props.onR}
       tipo={this.props.tipo}
        /></Modal.Body>
       
      </Modal>
    </>

      <>
      

        <Modal size="lg" centered show={this.state.show2_1} onHide={this.handleClose2_1} style={{marginTop:40,marginBottom:30}}>
          <Modal.Header  closeButton  style={{backgroundColor:'#731228',color:'white'}} closeVariant='white'>
            <Modal.Title>
  
              REQUISITOS
              
              </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.show2_1==true ? <RegistroOficio3 obj={this.props.obj}
       onR={this.props.onR}
       id_usuario={this.props.id_usuario}
        />  : null}
          </Modal.Body>
         
        </Modal>
      </>
         
      <>
      

      <Modal size="lg" centered show={this.state.show2_2} onHide={this.handleClose2_2} style={{marginTop:40,marginBottom:30}}>
      <Modal.Header  closeButton  style={{backgroundColor:'#731228',color:'white'}} closeVariant='white'>
            <Modal.Title>
  
              REQUISITOS
              
              </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.show2_2==true ? <RegistroOficio4 obj={this.props.obj}
       onR={this.props.onR}
       id_usuario={this.props.id_usuario}
        />  : null}
          </Modal.Body>
      </Modal>
    </>
      
      <>
      

      <Modal size="xl"  centered show={this.state.show3} onHide={this.handleClose3} style={{marginTop:40,marginBottom:30}}>
      <Modal.Header  align="center" closeButton  style={{backgroundColor:'#a02142',color:'white'}} closeVariant='white'>
            <center style={{color:'white',fontSize:20}} >{this.props.obj.id_estatus!=5 ? 'EMPAQUETADO' :''}  {this.props.obj.id_estatus==3 ? 'FIRMAS' : this.props.obj.id_estatus==4 ? 'PARA ENTREGAR' : 'ENTREGAR'}</center>
          </Modal.Header>
        <Modal.Body>
              SEGURO QUE QUIERE MANDAR ESTE TRAMITE A {this.props.obj.id_estatus==3 ? 'FIRMAS' : this.props.obj.id_estatus==4 ? 'PARA ENTREGAR' : 'ENTREGAR'} ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={()=>this.handleClose3()}>CANCELAR</Button>
          <Button variant='success' onClick={()=>{

const obj = {
     
  id_preregistro:this.props.obj.id_preregistro,
  id_estatus:this.props.obj.id_estatus==3 ? 4 : this.props.obj.id_estatus==4 ? 5 : 6,
  id_usuario:this.props.id_usuario,


 };
 console.log("cartilla obj");
 console.log(obj);

 
UPDCTE(obj).then(response => {  


  console.log(response);
 
 this.props.onR();
 this.handleClose3();
 
    }).catch(err => console.log(err));
         
          }}>{this.props.obj.id_estatus!=5 ? 'ENVIAR' :'Entregar'}</Button>

        </Modal.Footer>
      </Modal>
    </>

    <>
      

    <Modal size="lg" width= "100%" centered show={this.state.show4} onHide={this.handleClose4}>
    <Modal.Header  align="center" closeButton>
          <center><Modal.Title align="center">INFORMACIÓN CARTILLA</Modal.Title></center>
        </Modal.Header>
      <Modal.Body>
      <RegistroOficio2U obj={this.props.obj}
       onR={this.props.onR}
       id_usuario={this.props.id_usuario}
       hc={this.handleClose4}
       tipo={this.props.tipo}
        />
       </Modal.Body>
      
    </Modal>
  </>
         
  <>
      

      <Modal size="lg" idth= "100%" centered show={this.state.show5} onHide={this.handleClose5}>
      <Modal.Header  align="center" closeButton>
            <center><Modal.Title align="center"> Constancias</Modal.Title></center>
          </Modal.Header>
        <Modal.Body>
         
          </Modal.Body>
       <Modal.Footer>
     
      {(this.props.tipo==2 && this.props.index==2) ? null : <Button variant='secondary' onClick={()=>{this.setState({sm3:true,showCancelado:true,smn2:false,smn1:false,smn4:false});

var hoy = new Date();

var dd;

if(hoy.getDate()<10){
  dd="0"+hoy.getDate();
}else{
  dd= hoy.getDate();
}

var ms;

if((hoy.getMonth()+1)<10){
  ms="0"+(hoy.getMonth()+1);
}else{
  ms= (hoy.getMonth()+1);
}


var yyyy = hoy.getFullYear();
    let obj={
      id_preregistro:this.props.obj.id_preregistro,
      fechaConstancia:yyyy+'-'+ms+'-'+dd
    }

    console.log("obj cm");
    console.log(this.props.obj.fechaConstancia);
    console.log(obj);

    if(this.props.obj.fechaConstancia==null){
    UPDCTCM(obj).then(response => {  


      console.log(response);
     
    
     
        }).catch(err => console.log(err));
      
      }
    }}>Constancia Matricula</Button>}
      {(this.props.tipo==2 && this.props.index==0) ? null : <Button variant='secondary' onClick={()=>this.setState({sm4:true,showCancelado:true,smn2:false,smn3:false,smn1:false})}>Constancia No Registro</Button>}
       </Modal.Footer>
      </Modal>
    </>

    <>
      

      <Modal size="lg" idth= "100%" centered show={this.state.showCancelado} onHide={this.handleCloseCancelado}>
   
        <Modal.Body>
        {this.state.showCancelado ? [
        <PDFViewer width={'100%'} height={600} >
      {this.state.sm1 ? this.pdfsm(this.props.obj) : this.state.sm2 ? this.pdfsnr(this.props.obj) : this.state.sm3 ? this.pdfcs(this.props.obj) : this.state.sm4 ? this.pdfcsnr(this.props.obj) : null}
    </PDFViewer>,
    <PDFDownloadLink document={this.state.sm3 ? this.pdfcs(this.props.obj) : this.pdfcsnr(this.props.obj)} fileName={this.state.sm3 ? "cs-":"csnr-"+this.props.obj.matricula+".pdf"} >
    {({ blob, url, loading, error }) => (loading ? 'Loading document...' :  <Button  variant="outlined" color="primary" >Descargar</Button>)}
  </PDFDownloadLink>
  
  ] : null}
          </Modal.Body>
       
      </Modal>
    </>


    <>
      
      

      <Modal size="lg" idth= "100%" centered show={this.state.showDescancelado} onHide={this.handleCloseDesCancelado}>
      <Modal.Header  align="center" closeButton>
            <center><Modal.Title align="center">FORMATOS</Modal.Title></center>
          </Modal.Header>
        <Modal.Body>
        <center>
        <label style={{color:'#5B6B79',fontSize:'14px'}}>MARGEN HORIZONTAL = VALOR NEGATIVO(IZQUIERDA) Ó VALOR POSITIVO(DERECHA) </label>

                    <br/> 
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>MARGEN VERTICAL = VALOR NEGATIVO(ARRIBA) Ó VALOR POSITIVO(ABAJO) </label>
                    <br/>
                    <br/>

        <div className="form-group">

        <div className="form-group">
                <p>Margen Horizontal NOMBRE : {this.props.obj.nombre+" "+this.props.obj.ap_paterno+" "+this.props.obj.ap_materno}</p>
                <p style={{fontWeight:'bold', color:'orange'}}>  {(this.props.obj.nombre+" "+this.props.obj.ap_paterno+" "+this.props.obj.ap_materno).length>32 ? 'EL NOMBRE PUEDE REQUERIR AJUSTAR EL MARGEN HORIZONTAL' : ''}</p>

                </div>
                    <input 
                    style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                    type="number" 
                    required
                      className="form-control"
                      value={this.state.Margen}
                      onChange={(e)=>this.setState({Margen:e.target.value})}
                      />
                </div>
                <br/>
                            
   

                <div className="form-group">
                  
                    <label style={{color:'black',fontSize:'14px'}}>Margen Vertical Total</label>

                    <input 
                    style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                    type="number" 
                    required
                      className="form-control"
                      value={this.state.MargenT}
                      onChange={(e)=>this.setState({MargenT:e.target.value})}
                      />
                </div>

                <div className="form-group">
                  
                  <label style={{color:'black',fontSize:'14px'}}>Margen Horizontal Total</label>

                  <input 
                  style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                  type="number" 
                  required
                    className="form-control"
                    value={this.state.MargenH}
                    onChange={(e)=>this.setState({MargenH:e.target.value})}
                    />
              </div>
              
                </center>
          </Modal.Body>
          <Modal.Footer>
     
     <Button variant='secondary' onClick={()=>this.handleShowCN()}>FORMATO 1</Button>
   {/*  <Button variant='secondary' onClick={()=>this.handleShowCNa()}>FORMATO 1 v1</Button>*/}

     <Button variant='secondary' onClick={()=>this.handleShow()}>FORMATO 2</Button>
     </Modal.Footer>
      </Modal>
    </>

    <>
      

      <Modal size="lg" idth= "100%" centered show={this.state.show6} onHide={this.handleClose6}>
      <Modal.Header  align="center" closeButton>
            <center><Modal.Title align="center">CANCELAR TRAMITE</Modal.Title></center>
          </Modal.Header>
        <Modal.Body>
      SEGURO QUE QUIERE CANCELAR ESTE TRAMITE MATRICULA : {this.props.obj.matricula}?
                                               
        </Modal.Body>
        <Modal.Footer>
       
          <Button variant='secondary' onClick={()=>this.handleClose6()}>SALIR</Button>
          <Button variant='danger' onClick={()=>{

const obj = {
     
  id_preregistro:this.props.obj.id_preregistro,
  id_estatus:7,
  id_usuario:this.props.id_usuario,


 };
 console.log("cartilla obj");
 console.log(obj);

 
UPDCTE(obj).then(response => {  


  console.log(response);
 
 this.props.onR();
 this.handleClose6();
 
    }).catch(err => console.log(err));
         
          }}>CANCELAR TRAMITE</Button>


        </Modal.Footer>
      </Modal>
    </>

    <Modal size="lg" idth= "100%" centered show={this.state.show7} onHide={this.handleClose7}>
      <Modal.Header  align="center" closeButton>
            <center><Modal.Title align="center">Editar No Registro</Modal.Title></center>
          </Modal.Header>
          <Modal.Body>
            <Grid container spacing={2} style={{padding:'65px'}} >
            <Grid item xs={12}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>NOMBRE(S) </label>
               
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
      type="text" 
      className="form-control" 
      value={this.state.nombre}
      onChange={this.onChangenombre}
     
     
     
      />

      
      </Grid>

      <Grid item xs={6}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>APELLIDO PATERNO </label>
               
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
      type="text" 
      className="form-control" 
      value={this.state.ap_paterno}
      onChange={this.onChangeapellidopaterno}
     
     
     
      />

      
      </Grid>

      <Grid item xs={6}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>APELLIDO MATERNO </label>
               
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
      type="text" 
      className="form-control" 
      value={this.state.ap_materno}
      onChange={this.onChangeapellidomaterno}
     
     
     
      />

      
      </Grid>

      <Grid item xs={9}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>CURP </label>
               
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
      type="text" 
      className="form-control" 
      value={this.state.CURP}
      onChange={this.onChangecurp}
     
     
     
      />

      
      </Grid>

      <Grid item xs={3}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>Clase </label>
               
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
      type="text" 
      className="form-control" 
      value={this.state.clase}
      onChange={this.onChangeclase}
     
     
     
      />

      
      </Grid>

      <Grid item xs={5}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>Teléfono </label>
               
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
      type="text" 
      className="form-control" 
      value={this.state.telefono}
      onChange={this.onChangetelefono}
     
     
     
      />

      
      </Grid>

      <Grid item xs={7}>
                <label style={{color:'#5B6B79',fontSize:'14px'}}>Domicilio </label>
               
                <input 
                style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
      type="text" 
      className="form-control" 
      value={this.state.domicilio}
      onChange={this.onChangedomicilio}
     
     
     
      />

      
      </Grid>
              </Grid>
          
            </Modal.Body>
        <Modal.Footer>
      
        <Button variant='secondary' onClick={()=>this.handleClose7()}>Salir</Button>
          <Button variant='success' onClick={()=>{
     
const obj = {
     
  id_noregistro:this.props.obj.id_noregistro,
  ap_paterno:this.state.ap_paterno,
  ap_materno:this.state.ap_materno,
  nombre:this.state.nombre,
  CURP:this.state.CURP,
  clase:this.state.clase,
  domicilio:this.state.domicilio,
  telefono:this.state.telefono,

 };
 console.log("no registro obj");
 console.log(obj);


UPDNoregistro(obj).then(response => {  

  console.log(response);
 
 this.props.onR();
 this.handleClose7();
 
    }).catch(err => console.log(err));
         
          }}>GUARDAR</Button>
        </Modal.Footer>
      </Modal>

             <Modal size="lg" idth= "100%" centered show={this.state.show8} onHide={this.handleClose8}>

        <Modal.Body>
        </Modal.Body>
        <Modal.Footer>
     

        </Modal.Footer>
      </Modal> 



      <Modal size="lg" idth= "100%" centered show={this.state.show82} onHide={this.handleClose82}>
  
        <Modal.Body>
        </Modal.Body>
        <Modal.Footer>
       

        </Modal.Footer>
      </Modal> 





      <Modal 
           aria-labelledby="contained-modal-title-vcenter"
           size='xl'
          style={{marginTop:20,height:'100%',width:'100%'}}
           centered show={this.state.showFPC} onHide={this.handleCloseFPC}>
            
        <Modal.Body style={{backgroundColor:'#A02142'}}>
          <center>

         </center>
        </Modal.Body>
       
      </Modal>
        </tr>
    );
  }
}

export default TableRow;